import { render, staticRenderFns } from "./sub-bubble-agreements-container.vue?vue&type=template&id=3c2474c1"
import script from "./sub-bubble-agreements-container.vue?vue&type=script&lang=js"
export * from "./sub-bubble-agreements-container.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports